export default {
  'profile': {
    'info': 'Info',
    'password': 'Password',
    'avatar': 'Avatar',
    'group': 'Group',

    'my_info': 'My info',

    'nickname': 'Nickname',
    'email': 'Email',
    'introduce': 'Introduce',
    'introduce_enter': 'Enter introduce',
    'nickname_dont_empty': 'Nickname dont empty',
    'email_dont_empty': 'Email dont empty',
    'save': 'Save',
    'info_update_success': 'Info update successfully',

    'updata_avatar_tip': 'Updata avatar tip',
    'auto_update_avatar': 'Avatar will auto upload',
    'select_avatar': 'Select avatar',
    'update_avatar_success': 'Updata avatar successfully',

    'old_password': 'Oldpassword',
    'old_password_enter': 'Enter Oldpassword',
    'new_password': 'Newpassword',
    'new_password_enter': 'Enter Newpassword',
    'new_password_confirm': 'Newpassword confirm',
    'new_password_confirm_enter': 'Enter Newpassword confirm',
    'oldpassword_dont_empty': 'Oldpassword dont empty',
    'newpassword_dont_empty': 'Newpassword dont empty',
    'confirm_newpassword_dont_empty': 'Confirm newpassword  dont empty',
    'updata_password_success': 'Updata password successfully',
  },
}
